/**
 * Created by Ivan on 20.01.2026
 */

const WoodenSoftFeastRowView = cc.Scale9Sprite.extend({
    ctor: function (row, options) {
        options = options || {};

        this.id = row.id;
        this.row = row;
        this.options = options;

        options.prizes = options.prizes !== undefined ? options.prizes : true;
        options.badges = options.badges !== undefined ? options.badges : true;

        const styles = cleverapps.styles.WoodenSoftFeastRowView;

        this.clickableArea = options.clickableArea;

        const background = this.isPlayer() ? bundles.table.frames.row_you_png : bundles.table.frames.row_player_png;
        this._super(background, cleverapps.UI.getScale9Rect(background, cleverapps.UI.Scale9Rect.TwoPixelXY));

        if (this.isPlayer() && bundles.table.frames.row_you_frame_png) {
            const bg = this.bg = cleverapps.UI.createScale9Sprite(bundles.table.frames.row_you_frame_png, cleverapps.UI.Scale9Rect.TwoPixelXY);
            bg.setAlignment({ align: "center" }, { align: "center" });
            bg.setLocalZOrder(1);
            this.addChild(bg);
        }

        this.updatePlace(row.data.place);

        const place = this.createPlace(row.data.place);
        const avatar = this.avatar = this.createAvatar();
        const name = this.name = this.createName();
        name.setAlignment(styles.name);

        const prize = this.createPrize();

        const score = this.scoreNode = this.createScore();

        cleverapps.tooltipManager.create(score, {
            text: Messages.get(this.options.scoreTooltip || "ResultTooltip"),
            location: cleverapps.UI.Tooltip.LOCATION_BELOW,
            clickableArea: this.clickableArea
        });

        const nameWrapper = this.nameWrapper = new cc.Node();
        nameWrapper.setAnchorPoint(0.5, 0.5);
        nameWrapper.addChild(name);
        this.content = new cleverapps.Layout([place, avatar, nameWrapper, prize, score].filter(Boolean), {
            direction: cleverapps.UI.HORIZONTAL
        });

        if (options.mission && this.isPlayer() && cleverapps.config.debugMode) {
            cleverapps.UI.onClick(this, () => {
                options.mission.update(10);
            });
        }

        this.addChild(this.content);
        this.onResize();
        this.content.setAlignment(styles.content);
    },

    isPlayer: function () {
        return this.row.data.player;
    },

    onResize: function () {
        const styles = cleverapps.styles.WoodenSoftFeastRowView;

        cleverapps.UI.fitToBox(this.avatar, {
            height: styles.content.height,
            maxScale: cleverapps.resolution.isVertical() ? styles.avatar.verticalScale : 1
        });

        if (this.prizeNode) {
            cleverapps.UI.fitToBox(this.prizeNode, {
                width: cleverapps.resolution.isVertical() ? styles.prize.verticalWidth : styles.prize.width,
                height: styles.content.height
            });
        }

        let width = this.options.width || styles.width;
        if (this.options.dynamicWidth) {
            width = Math.max(styles.minWidth, Math.min(width, cleverapps.resolution.getSceneSize().width - styles.scenePadding[cleverapps.resolution.mode] * 2));
        }

        this.setContentSize2(width, styles.height);
        if (this.bg) {
            this.bg.setContentSize2(width, styles.height);
        }
        const margin = cleverapps.resolution.isVertical() ? styles.content.verticalMargin : styles.content.margin;

        const nameWidth = width - 2 * styles.paddingX - [this.placeNode, this.avatar, this.prizeNode, this.scoreNode].filter(Boolean).reduce((width, item) => width + item.width * item.scaleX + margin, 0);

        cleverapps.UI.fitToBox(this.name, {
            width: nameWidth,
            height: styles.name.height
        });

        this.nameWrapper.setContentSize2(nameWidth, styles.height);
        this.content.setOptions({ margin });
    },

    createPlace: function (place) {
        const styles = cleverapps.styles.WoodenSoftFeastRowView;

        const placeNode = this.placeNode || new cc.Node();
        this.placeNode = placeNode;
        placeNode.setAnchorPoint(0.5, 0.5);

        placeNode.removeAllChildren();

        let content;
        const badgeIcon = bundles.table.frames[`badge_${place}`];
        if (this.options.badges && badgeIcon) {
            content = new cc.Sprite(badgeIcon);
        } else {
            content = cleverapps.UI.generateImageText(
                this.row.data.notInTop ? "-" : place,
                this.isPlayer() ? cleverapps.styles.FONTS.WOODEN_SOFTFEAST_ROW_MISSION_PLAYER_TEXT : cleverapps.styles.FONTS.WOODEN_SOFTFEAST_ROW_MISSION_TEXT
            );
        }

        placeNode.setContentSize2(
            Math.max(
                this.options.badges && styles.place.withBadge.width || 0,
                styles.place.background ? styles.place.background.width : styles.place.width
            ),
            styles.content.height
        );

        placeNode.addChild(content);
        content.setAlignment(placeNode.width / 2, placeNode.height / 2);

        return placeNode;
    },

    createAvatar: function () {
        return new cleverapps.UI.Avatar(this.row.data.avatar, {
            userId: this.row.id,
            frame: this.isPlayer() ? bundles.table.frames.table_avatar_frame2 : bundles.table.frames.table_avatar_frame,
            padding: cleverapps.styles.WoodenSoftFeastRowView.avatar.padding
        });
    },

    createName: function () {
        const userName = this.row.data.name
            || typeof this.row.id === "string" && `Player_${this.row.id.substring(this.row.id.length - 3)}` || "";

        const font = this.isPlayer() ? cleverapps.styles.FONTS.WOODEN_SOFTFEAST_ROW_MISSION_PLAYER_TEXT : cleverapps.styles.FONTS.WOODEN_SOFTFEAST_ROW_MISSION_TEXT;

        return cleverapps.UI.generateOnlyText(userName, font);
    },

    createPrize: function () {
        if (!this.options.prizes) {
            return;
        }

        const styles = cleverapps.styles.WoodenSoftFeastRowView;

        const width = cleverapps.resolution.isVertical() ? styles.prize.verticalWidth : styles.prize.width;

        const prizeNode = this.prizeNode || new cc.Node();
        this.prizeNode = prizeNode;
        prizeNode.setAnchorPoint(0.5, 0.5);
        prizeNode.removeAllChildren();
        cleverapps.tooltipManager.remove(prizeNode);

        prizeNode.setContentSize2(width, styles.content.height);

        const prizeIcon = this.prizeIcon = this.row.data.prizeIcon;
        if (prizeIcon) {
            const prize = new cc.Sprite(prizeIcon);
            prizeNode.addChild(prize);
            prize.setAlignment({ x: { align: "center" }, y: { align: "center" } });

            cleverapps.tooltipManager.create(prizeNode, {
                rewards: this.row.data.prizeRewards,
                clickableArea: this.clickableArea
            });
        }

        return prizeNode;
    },

    createScore: function () {
        const styles = cleverapps.styles.WoodenSoftFeastRowView.score;

        const image = this.isPlayer() ? bundles.table.frames.amount_bg_you_png : bundles.table.frames.amount_bg_png;

        const background = new cc.Scale9Sprite(image);

        let icon;

        if (this.options.dataIcon) {
            icon = this.scoreIcon = new cc.Sprite(this.options.dataIcon);
            icon.setAlignment(styles.icon);
            background.addChild(icon);
        }

        const amount = this.scoreAmount = cleverapps.UI.generateImageText("222", cleverapps.styles.FONTS.WOODEN_SOFTFEAST_ROW_MISSION_SCORE_TEXT);

        background.addChild(amount);

        background.onResize = function () {
            background.setContentSize2(cleverapps.resolution.isVertical() ? styles.verticalWidth : styles.width, styles.height);
            amount.setAlignment((background.width + (icon ? icon.x + icon.width / 4 : 0)) / 2, background.height / 2);
            amount.fitToSize = {
                width: (background.width - (icon ? icon.x + icon.width / 4 : 0)) * 0.9,
                height: background.height * 0.9
            };
            this.updateScore(this.row.score, { silent: true });
        }.bind(this);
        background.onResize();

        return background;
    },

    updatePlace: function (place) {
        if (this.place === place) {
            return;
        }
        this.place = place;

        this.createPlace(this.place);
        this.updateLocalZOrder();
    },

    updateLocalZOrder: function () {
        this.setLocalZOrder(this.isPlayer() ? 1000 : this.place);
    },

    updateScore: function (score, options) {
        options = options || {};

        if (!this.scoreAmount || this.score === score) {
            return;
        }

        this.score = score;

        this.scoreAmount.stopAllActions();
        this.scoreAmount.setString(this.score);
        this.scoreAmount.fitTo(this.scoreAmount.fitToSize.width, this.scoreAmount.fitToSize.height);

        if (options.silent) {
            return;
        }

        this.scoreAmount.runAction(new cc.Sequence(
            new cc.ScaleTo(0.2, 1.5),
            new cc.ScaleTo(0.2, 1)
        ));

        if (this.scoreIcon && this.options.dataIconAnimation && this.isPlayer()) {
            const animation = new cleverapps.Spine(this.options.dataIconAnimation);
            animation.setAnimation(0, "animation");
            animation.setLocalZOrder(100);
            this.addChild(animation);

            const updatePosition = function () {
                const parent = animation.parent;
                animation.setPosition(parent.convertToNodeSpace(this.scoreIcon.parent.convertToWorldSpace(this.scoreIcon.getPosition())));
                animation.setVisible(cc.rectContainsPoint(cc.rect(0, 0, parent.width, parent.height), animation.getPosition()));
            }.bind(this);

            animation.update = function (dt) {
                cleverapps.Spine.prototype.update.call(this, dt);
                updatePosition();
            }.bind(this);

            animation.scheduleUpdate();
            updatePosition();

            animation.replaceParentSamePlace(this.clickableArea, { keepScale: true });

            cleverapps.effects.fire(this.options.dataIconAnimationEffect);
        }
    },

    updatePrize: function () {
        if (!this.options.prizes || this.prizeIcon === this.row.data.prizeIcon) {
            return;
        }

        this.createPrize();
        this.prizeNode.runAction(new cc.Sequence(
            new cc.ScaleTo(0.2, 1.1),
            new cc.ScaleTo(0.2, 1)
        ));
    },

    updateRow: function (row) {
        this.row = row;

        this.updatePlace(this.row.data.place);
        this.updatePrize();
        this.updateScore(this.row.score);
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    WOODEN_SOFTFEAST_ROW_MISSION_SCORE_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },
    WOODEN_SOFTFEAST_ROW_MISSION_PLAYER_TEXT: {
        name: "nostroke",
        size: 40,
        color: new cc.Color(42, 83, 170, 255)
    },
    WOODEN_SOFTFEAST_ROW_MISSION_TEXT: {
        name: "nostroke",
        size: 40,
        color: new cc.Color(164, 72, 64, 255)
    }
});

cleverapps.styles.WoodenSoftFeastRowView = {
    width: 1030,
    height: 116,
    minWidth: 700,
    scenePadding: [100, 250, 250],

    paddingX: 40,

    content: {
        height: 94,
        margin: 16,
        verticalMargin: 16,
        x: { align: "center" },
        y: { align: "center", dy: 3 }
    },

    place: {
        withBadge: {
            width: 50
        },

        width: 50
    },

    name: {
        height: 50,

        x: { align: "left" },
        y: { align: "center", dy: -3 }
    },

    avatar: {
        padding: {
            x: 6,
            top: 6,
            bottom: 6
        },
        verticalScale: 1
    },

    prize: {
        width: 100,
        verticalWidth: 100
    },

    score: {
        width: 160,
        verticalWidth: 140,
        height: 64,

        icon: {
            x: 10,
            y: { align: "center" }
        }
    }
};
